import Automation, { type AutomationProps } from "./automation";

export interface AutomationSettings {
  enabled: boolean;
  selectedValues: string[];
}

interface HistoricNarAutomationFieldsProps {
  options: AutomationProps["options"];
  agenticAutomation: AutomationSettings;
  touchlessAutomation: AutomationSettings;
  onAgenticChange: (settings: AutomationSettings) => void;
  onTouchlessChange: (settings: AutomationSettings) => void;
}

/** Controlled agentic and touchless selectors for the ingest form. */
const HistoricNarAutomationFields = ({
  options,
  agenticAutomation,
  touchlessAutomation,
  onAgenticChange,
  onTouchlessChange,
}: HistoricNarAutomationFieldsProps) => (
  <>
    <Automation
      options={options}
      toggleProps={{
        id: "agentic",
        defaultValue: agenticAutomation.enabled,
        onChange: ({ value }) =>
          onAgenticChange({ ...agenticAutomation, enabled: value }),
      }}
      value={agenticAutomation.selectedValues}
      onChange={(selectedValues) =>
        onAgenticChange({ ...agenticAutomation, selectedValues })
      }
    />
    <Automation
      options={options}
      agentModeLabel="Touchless"
      selectionLabel="Enable Touchless For"
      toggleProps={{
        id: "touchless",
        defaultValue: touchlessAutomation.enabled,
        onChange: ({ value }) =>
          onTouchlessChange({ ...touchlessAutomation, enabled: value }),
      }}
      value={touchlessAutomation.selectedValues}
      onChange={(selectedValues) =>
        onTouchlessChange({ ...touchlessAutomation, selectedValues })
      }
    />
  </>
);

export default HistoricNarAutomationFields;
